import { render, staticRenderFns } from "./SizeAdjustButton.vue?vue&type=template&id=180dabf6"
import script from "./SizeAdjustButton.vue?vue&type=script&lang=js"
export * from "./SizeAdjustButton.vue?vue&type=script&lang=js"
import style0 from "./SizeAdjustButton.vue?vue&type=style&index=0&id=180dabf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports